export default __webpack_public_path__ + "static/media/message-black.b7e5ee95.png";